import React from 'react';

/**
 * Компонент Button - универсальная кнопка с различными стилями
 * 
 * @param {ReactNode} children - Содержимое кнопки
 * @param {boolean} primary - Основной стиль кнопки (true) или вторичный (false)
 * @param {string} className - Дополнительные классы CSS
 * @param {function} onClick - Обработчик клика
 * @param {ReactNode} icon - Иконка для отображения перед текстом
 * @param {string} size - Размер кнопки (sm, md, lg)
 * @param {boolean} disabled - Отключена ли кнопка
 * @param {boolean} fullWidth - Растягивать ли кнопку на всю ширину контейнера
 * @param {string} type - Тип кнопки (button, submit, reset)
 */
const Button = ({ 
  children, 
  primary = false, 
  className = "", 
  onClick, 
  icon, 
  size = "md",
  disabled = false,
  fullWidth = false,
  type = "button",
  ...rest
}) => {
  // Базовые классы для всех кнопок
  const baseClasses = "relative transition-all duration-200 ease-out rounded-lg font-medium flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50";
  
  // Классы для разных стилей кнопки
  const styleClasses = primary 
    ? 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-sm disabled:bg-indigo-300' 
    : 'bg-white hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 disabled:bg-gray-100 dark:disabled:bg-gray-900 disabled:text-gray-400';
  
  // Классы для разных размеров кнопки
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg',
  }[size];
  
  // Класс для кнопки на всю ширину
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        ${baseClasses}
        ${styleClasses}
        ${sizeClasses}
        ${widthClass}
        ${className}
      `}
      {...rest}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
};

export default Button;